import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ProposalItemLogApi } from 'api';

export const findProposalItemLog = createAsyncThunk(
  'proposalItemLog/findProposalItemLog',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await ProposalItemLogApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProposalItemLog = createAsyncThunk(
  'proposalItemLog/updateProposalItemLog',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await ProposalItemLogApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  list: Array<any>;
}

const initialState: State = {
  list: [],
};

const proposalItemLogSlice = createSlice({
  name: 'proposalItemLog',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findProposalItemLog.fulfilled, (state, action) => {
      const { data } = action.payload;
      const newData = data.map(item => {
        return {
          key: item.id,
          ...item,
        };
      });
      state.list = newData;
    });
  },
});

const { reducer: proposalItemLogReducer } = proposalItemLogSlice;

export default proposalItemLogReducer;
